import React from 'react';
import { DocumentIcon } from '@heroicons/react/24/outline';
import LectureCard from './LectureCard';

const LectureGrid = ({ 
  loading, 
  lectures, 
  filteredLectures, 
  getThumbnailUrl, 
  confirmDelete, 
  handleLectureView, 
  getBadgeText 
}) => {
  return (
    <div className="lectures-grid-wrapper overflow-y-auto mt-2" style={{ height: 'calc(100vh - 280px)' }}>
      {loading && lectures.length === 0 ? (
        <div className="flex justify-center items-center py-12">
          <div className="flex flex-col items-center space-y-4">
            <div className="relative">
              <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <i className="pi pi-book text-blue-600 text-xl"></i>
              </div>
            </div>
            <div className="flex flex-col items-center">
              <span className="text-lg font-bold text-gray-900">Loading Lectures</span>
              <span className="text-sm text-gray-500 italic">Please wait while we fetch your lectures...</span>
            </div>
          </div>
        </div>
      ) : lectures.length === 0 ? (
        <div className="lectures-empty">
          <DocumentIcon className="lectures-empty-icon" />
          <p>No lectures available yet</p>
        </div>
      ) : filteredLectures.length === 0 ? (
        <div className="lectures-empty">
          <DocumentIcon className="lectures-empty-icon" />
          <p>No lectures match your search</p>
        </div>
      ) : (
        <div className="lectures-grid">
          {filteredLectures.map((lecture) => (
            <LectureCard 
              key={lecture.id}
              lecture={lecture}
              getThumbnailUrl={getThumbnailUrl}
              confirmDelete={confirmDelete}
              handleLectureView={handleLectureView}
              getBadgeText={getBadgeText}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default LectureGrid;
